// app/javascript/controllers/drawer_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["sheet"];

  connect() {
    this.isOpen = false;
    this.startY = 0;
    this.currentY = 0;
    this.isDragging = false;

    // Bind touch gestures directly to the sliding sheet container
    this.touchStartHandler = this.onTouchStart.bind(this);
    this.touchMoveHandler = this.onTouchMove.bind(this);
    this.touchEndHandler = this.onTouchEnd.bind(this);

    this.sheetTarget.addEventListener("touchstart", this.touchStartHandler, {
      passive: true,
    });
    this.sheetTarget.addEventListener("touchmove", this.touchMoveHandler, {
      passive: false,
    });
    this.sheetTarget.addEventListener("touchend", this.touchEndHandler, {
      passive: true,
    });
  }

  disconnect() {
    if (this.hasSheetTarget) {
      this.sheetTarget.removeEventListener(
        "touchstart",
        this.touchStartHandler,
      );
      this.sheetTarget.removeEventListener("touchmove", this.touchMoveHandler);
      this.sheetTarget.removeEventListener("touchend", this.touchEndHandler);
    }
  }

  // Bound directly to your "More" navigation tab button
  toggle(event) {
    if (event) event.preventDefault();
    this.isOpen ? this.close() : this.open();
  }

  open() {
    this.isOpen = true;
    // Premium fluid spring easing matching native Android 14 surfaces
    this.sheetTarget.style.transition =
      "transform 0.4s cubic-bezier(0.1, 0.9, 0.2, 1)";
    this.sheetTarget.style.transform = "translateY(0%)";
  }

  close() {
    this.isOpen = false;
    this.sheetTarget.style.transition =
      "transform 0.3s cubic-bezier(0.2, 0.8, 0.2, 1)";
    this.sheetTarget.style.transform = "translateY(100%)";
  }

  onTouchStart(event) {
    // Intercept tracking loops if clicking form fields or active actions
    if (event.target.closest("input, select, textarea, button, a")) return;

    this.startY = event.touches[0].clientY;
    this.currentY = this.startY;
    this.isDragging = true;

    // Kill transitions completely so sheet locks 1:1 underneath finger placement
    this.sheetTarget.style.transition = "none";
  }

  onTouchMove(event) {
    if (!this.isDragging) return;

    this.currentY = event.touches[0].clientY;
    const deltaY = this.currentY - this.startY;

    if (deltaY > 0) {
      if (event.cancelable) event.preventDefault();
      // Translate the panel exactly at the finger offset speed
      this.sheetTarget.style.transform = `translateY(${deltaY}px)`;
    }
  }

  onTouchEnd() {
    if (!this.isDragging) return;
    this.isDragging = false;

    const deltaY = this.currentY - this.startY;

    // If drag delta exceeds threshold, slide out; otherwise, snap back open cleanly
    if (deltaY > 110) {
      this.close();
    } else {
      this.open();
    }

    this.startY = 0;
    this.currentY = 0;
  }
}
